import App from 'components/app';
import Home from 'components/home';
import rest from "api/rest";

import {Login, ListCategories, AddCategory, EditCategory, Notification, Validators} from "pages";
import {ListBusinesses, AddBusiness, EditBusiness, ListAwaitingBusinesses, ListRejectedBusinesses} from 'pages/businesses';
import {ListPromotions, AddPromotion, EditPromotion} from 'pages/promotions';
import {ListTopBusinesses, AddTopBusiness, EditTopBusiness} from 'pages/top-businesses';
import {ListArticles, AddArticle, EditArticle} from 'pages/articles';
import {ListArticleCategories, AddArticleCategory, EditArticleCategory} from 'pages/article-categories';
import {ListProductsByBusiness, AddProduct, EditProduct, ApprovedProducts, AwaitingProducts, RejectedProducts} from 'pages/products';
import {RequestsContainer, RequestDetail} from 'pages/requests';
import {DemandsContainer, DemandDetail} from 'pages/demands';
import {SubscriptionsContainer, SubscriptionMailContent} from 'pages/subscriptions';
import {ComplainsContainer, ComplainDetail} from 'pages/complains';
import {OrdersContainer, ClosedOrdersContainer, OrderDetailContainer, CancelledOrdersContainer} from 'pages/orders';
import {ContactsContainer} from 'pages/contacts';
import {UsersContainer, AddUser, EditUser} from 'pages/users';
import {ListFAQs, AddFAQ, EditFAQ} from 'pages/faqs';
import {ListHomeBanners, AddHomeBanner, EditHomeBanner} from 'pages/home-banners';

const {actions} = rest;

const routes = [
  {
    component: App,
    routes: [
      {
        component: Login,
        exact: true,
        path: '/',
      },
      {
        path: "/home",
        exact: true,
        component: Home
      },
      {
        path: "/categories",
        exact: true,
        component: ListCategories,
        activeMenu: 'quan-ly-chung'
      },
      {
        path: "/categories/add",
        exact: true,
        component: AddCategory,
        activeMenu: 'quan-ly-chung'
      },
      {
        path: "/categories/edit/:id",
        exact: true,
        component: EditCategory,
        activeMenu: 'quan-ly-chung'
      },
      {
        path: "/home-banners",
        exact: true,
        component: ListHomeBanners,
        activeMenu: 'quan-ly-chung'
      },
      {
        path: "/home-banners/add",
        exact: true,
        component: AddHomeBanner,
        activeMenu: 'quan-ly-chung'
      },
      {
        path: "/home-banners/edit/:id",
        exact: true,
        component: EditHomeBanner,
        activeMenu: 'quan-ly-chung'
      },
      {
        path: "/businesses/awaiting",
        exact: true,
        component: ListAwaitingBusinesses,
        activeMenu: 'quan-ly-doanh-nghiep'
      },
      {
        path: "/businesses/rejected",
        exact: true,
        component: ListRejectedBusinesses,
        activeMenu: 'quan-ly-doanh-nghiep'
      },
      {
        path: "/businesses",
        exact: true,
        component: ListBusinesses,
        activeMenu: 'quan-ly-doanh-nghiep'
      },
      {
        path: "/businesses/add",
        exact: true,
        component: AddBusiness,
        activeMenu: 'quan-ly-doanh-nghiep'
      },
      {
        path: "/businesses/edit/:id",
        exact: true,
        component: EditBusiness,
        activeMenu: 'quan-ly-doanh-nghiep'
      },
      {
        path: "/article-categories",
        exact: true,
        component: ListArticleCategories,
        activeMenu: 'tin-bai'
      },
      {
        path: "/article-categories/add",
        exact: true,
        component: AddArticleCategory,
        activeMenu: 'tin-bai'
      },
      {
        path: "/article-categories/edit/:id",
        exact: true,
        component: EditArticleCategory,
        activeMenu: 'tin-bai'
      },
      {
        path: "/business/:id/products",
        exact: true,
        component: ListProductsByBusiness,
        activeMenu: 'quan-ly-doanh-nghiep'
      },
      {
        path: "/business/:id/products/add",
        exact: true,
        component: AddProduct,
        activeMenu: 'quan-ly-doanh-nghiep'
      },
      {
        path: "/products/awaiting",
        exact: true,
        component: AwaitingProducts,
        activeMenu: 'quan-ly-san-pham'
      },
      {
        path: "/products",
        exact: true,
        component: ApprovedProducts,
        activeMenu: 'quan-ly-san-pham'
      },
      {
        path: "/products/rejected",
        exact: true,
        component: RejectedProducts,
        activeMenu: 'quan-ly-san-pham'
      },
      {
        path: "/products/edit/:id",
        exact: true,
        component: EditProduct,
        activeMenu: 'quan-ly-san-pham'
      },
      {
        path: "/article-categories",
        exact: true,
        component: ListArticleCategories,
        activeMenu: 'tin-bai'
      },
      {
        path: "/article-categories/add",
        exact: true,
        component: AddArticleCategory,
        activeMenu: 'tin-bai'
      },
      {
        path: "/article-categories/edit/:id",
        exact: true,
        component: EditArticleCategory,
        activeMenu: 'tin-bai'
      },
      {
        path: "/promotions",
        exact: true,
        component: ListPromotions,
        activeMenu: 'tin-bai'
      },
      {
        path: "/promotions/add",
        exact: true,
        component: AddPromotion,
        activeMenu: 'tin-bai'
      },
      {
        path: "/promotions/edit/:id",
        exact: true,
        component: EditPromotion,
        activeMenu: 'tin-bai'
      },
      {
        path: "/top-businesses",
        exact: true,
        component: ListTopBusinesses,
        activeMenu: 'top-business'
      },
      {
        path: "/top-businesses/add",
        exact: true,
        component: AddTopBusiness,
        activeMenu: 'top-business'
      },
      {
        path: "/top-businesses/edit/:id",
        exact: true,
        component: EditTopBusiness,
        activeMenu: 'top-business'
      },
      {
        path: "/articles",
        exact: true,
        component: ListArticles,
        activeMenu: 'tin-bai'
      },
      {
        path: "/articles/add",
        exact: true,
        component: AddArticle,
        activeMenu: 'tin-bai'
      },
      {
        path: "/articles/edit/:id",
        exact: true,
        component: EditArticle,
        activeMenu: 'tin-bai'
      },
      {
        path: "/faqs",
        exact: true,
        component: ListFAQs,
        activeMenu: 'tin-bai'
      },
      {
        path: "/faqs/add",
        exact: true,
        component: AddFAQ,
        activeMenu: 'tin-bai'
      },
      {
        path: "/faqs/:id",
        exact: true,
        component: EditFAQ,
        activeMenu: 'tin-bai'
      },
      // requests
      {
        path: "/requests",
        exact: true,
        component: RequestsContainer,
        activeMenu: 'quan-ly-yeu-cau'
      },
      // requests
      {
        path: "/requests/:id",
        exact: true,
        component: RequestDetail,
        activeMenu: 'quan-ly-yeu-cau'
      },
      // demands
      {
        path: "/demands",
        exact: true,
        component: DemandsContainer,
        activeMenu: 'quan-ly-nhu-cau-dang'
      },
      // demands
      {
        path: "/demands/:id",
        exact: true,
        component: DemandDetail,
        activeMenu: 'quan-ly-nhu-cau-dang'
      },
      // demands
      {
        path: "/subscriptions",
        exact: true,
        component: SubscriptionsContainer,
        activeMenu: 'danh-ba-nhan-tin'
      },
      // demands
      {
        path: "/subscriptions/content",
        exact: true,
        component: SubscriptionMailContent,
        activeMenu: 'danh-ba-nhan-tin'
      },
      // demands
      {
        path: "/complains",
        exact: true,
        component: ComplainsContainer,
        activeMenu: 'khieunai-gopy'
      },
      // demands
      {
        path: "/complains/:id",
        exact: true,
        component: ComplainDetail,
        activeMenu: 'khieunai-gopy'
      },
      {
        path: "/orders",
        exact: true,
        component: OrdersContainer,
        activeMenu: 'quan-ly-don-hang'
      },
      {
        path: "/orders/closed",
        exact: true,
        component: ClosedOrdersContainer,
        activeMenu: 'quan-ly-don-hang'
      },
      {
        path: "/orders/cancelled",
        exact: true,
        component: CancelledOrdersContainer,
        activeMenu: 'quan-ly-don-hang'
      },

      {
        path: "/orders/:id",
        exact: true,
        component: OrderDetailContainer,
        activeMenu: 'quan-ly-don-hang'
      },
      {
        path: "/contacts",
        exact: true,
        component: ContactsContainer,
        activeMenu: 'thong-tin-lien-he'
      },
      // Manage users
      // products
      {
        path: "/users",
        exact: true,
        component: UsersContainer,
        activeMenu: 'quan-ly-nguoi-dung'
      },
      {
        path: "/users/:id/edit",
        exact: true,
        component: EditUser,
        activeMenu: 'quan-ly-nguoi-dung'
      },
      {
        path: "/users/add",
        exact: true,
        component: AddUser,
        activeMenu: 'quan-ly-nguoi-dung'
      }
    ]
  }
];

export default routes;



// WEBPACK FOOTER //
// ./routes/routes.js